/**
 * Meeting APIs
 * @namespace MeetingApis
 */

import Api from "@/helpers/fetch"


export default class MeetingApis {
    /**
     * Get meeting info
     * @param {string} meetingId
     * @param {Function} callback
     */
    static async getMeetingInfo({meetingId, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/${meetingId}`
        const res =  await Api.fetch({
            url,
            method : "GET",
        })
        
        if(res) callback(res);
    }

    /**
     * Get meeting list
     * @param {Function} callback
     */
    static async getMeetingList ({callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings`
        const res =  await Api.fetch({
            url,
            method : "GET",
        })
        
        if(res) callback(res);
    }


    /**
     * Toggle complete meeting task
     * @param {Number} task_id - Task id
     * @param {Number} meeting_id - Meeting id
     * @param {Number} user_id - User id
     * @param {Function} callback 
     */
    static async toggleCompleteTask({task_id, meeting_id, user_id, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/complete_task`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {task_id, meeting_id, user_id}
        })

        if(res) callback(res)
    }

    /**
     * Toggle attendance 
     * @param {Number} meeting_id - Meeting id
     * @param {Number} user_id - User id
     * @param {Number} task_id - Task id (attendnace task id)
     * @param {Function} callback 
     */
    static async toggleAttendance({meeting_id, user_id, task_id, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/complete_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {meeting_id, user_id, task_id}
        })

        if(res) callback(res)
    }

    /**
     * Create meeting
     * @param {Object} meeting - Meeting object
     * @param {Function} callback 
     */
    static async createMeeting({meeting, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : meeting
        })

        if(res) callback(res)
    }

    /**
     * Update meeting
     * @param {Object} params - Meeting object, {meeting_id, ...params}
     * @param {Function} callback 
     */
    static async updateMeeting({params, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/${params.meeting_id}`
        const res = await Api.fetch({
            url,
            method : "PUT",
            params
        })

        if(res) callback(res)
    }

    /**
     * Add attendance api
     * @param {Object} params - Meeting object, {meeting_id, ...params}
     */

    static async addAttendance({params, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/add_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Delete meeting
     * @param {Number} meeting_id - Meeting id
     * @param {Function} callback 
     */
    static async deleteMeeting({meeting_id, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/${meeting_id}`
        const res = await Api.fetch({
            url,
            method : "DELETE",
        })

        if(res) callback(res)

    }

    /**
     * Add assignment 
     * @param {Object}  params - Meeting id
     * @param {String} task_name
     */
    static async addAssignment({params, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/add_assignment`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Remove user from attendance
     * @param {Number} meeting_id - Meeting id
     * @param {Number} user_id - User id
     * @param {Number} type - Type of attendance
     */
    static async removeUserFromAttendance({meeting_id, user_id, type, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/remove_attendance`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {meeting_id, task_id : user_id, type}
        })

        if(res) callback(res)
    }

    /**
     * Remove task
     * @param {Number} meeting_id - Meeting id
     * @param {Number} task_id - Task id
     * @param {String} type - Type of task - individual or group
     * @param {Function} callback 
     */
    static async removeTask({meeting_id, task_id, type = "individual", callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/remove_assignment`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {meeting_id, task_id, type}
        })

        if(res) callback(res)
    }

    /**
     * Assign user to task
     * @param {Number} meeting_id - Meeting id
     * @param {Number} task_id - Task id
     * @param {Number} assign_to_user - Array of user ids
     * @param {String} type  - Individual or group
     * @param {Function} callback 
     */
    static async assignUserToTask({meeting_id, task_id, assign_to_user, type="individual", callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/add_user_assignment`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {meeting_id, task_id, assign_to_user, type}
        })

        if(res) callback(res)
    }

    /**
     * Update task
     * @param {Object} params - task object
     * @param {Function} callback 
     */
    static async updateTask({params, callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/update_assignment`
        const res = await Api.fetch({
            url,
            method : "POST",
            params
        })

        if(res) callback(res)
    }

    /**
     * Remove user from task
     * @param {Number} meeting_id - Meeting id
     * @param {Number} task_id - Task id
     * @param {Number} assign_to_user - User ids
     * @param {String} type - Type of task - individual or group
     * @param {Function} callback 
     */
    static async removeTaskUser({meeting_id, task_id, assign_to_user, type = "individual", callback = () => {}} = {}) {
        const url = `stakeapi/v1/meetings/remove_user_assignment`
        const res = await Api.fetch({
            url,
            method : "POST",
            params : {meeting_id, task_id, assign_to_user, type}
        })

        if(res) callback(res)
    }
}